import { ButtonPrimary } from "components/Atoms/Button";
import { PreviewPanelDetailRow } from "components/Atoms/details/PreviewPanelDetailRow";
import { CompanySmallDetails } from "components/SmallDetails";
import React, { useEffect } from "react";
import { PlaceholderContent } from "supportbeacon/articleplaceholders";
import { useApi } from "utilities/hookutils";
import { routes } from "utilities/routing/generatedRoutes";
import { PreviewPanel, PreviewPanelContent, PreviewPanelFooter, PreviewPanelHeader } from "../PreviewPanel";
import { BankAccountsSection } from "./BankAccountsSection";
import { EInvoiceSenderComplianceMessage } from "bookkeeping/detail/EInvoiceSenderComplianceMessage";
interface BookkeepingPreviewPanelProps {
  bookkeepingId: number
}

const BookkeepingPreviewPanel = (props: BookkeepingPreviewPanelProps) => {
  const { bookkeepingId } = props

  const api = useApi(() => window.CoreApi.Bookkeeping.GetPreviewPanelData(bookkeepingId), ["bookkeeping", bookkeepingId], {
    startEnabled: true
  });

  useEffect(() => {
    api.refetch();
  }, [bookkeepingId]);

  if (api.isLoading) {
    return <>
      <PreviewPanelHeader title={RESX.Bookkeeping.resxBookkeeping} />
      <PreviewPanelContent>
        <PlaceholderContent />
      </PreviewPanelContent>
      <PreviewPanelFooter />
    </>;
  }

  const { bookkeeping, eInvoiceCompliance, bankAccounts } = api.data.data;

  return <>
    <PreviewPanelHeader title={RESX.Bookkeeping.resxBookkeeping} />
    <PreviewPanelContent>
      <div className="flex-column gap-larger">
        <PreviewPanelDetailRow labelTop={RESX.GeneralLabels.Name}>
          {bookkeeping.name}
        </PreviewPanelDetailRow>

        <PreviewPanelDetailRow labelTop={RESX.Bookkeeping.Code}>
          {bookkeeping.code}
        </PreviewPanelDetailRow>

        <PreviewPanelDetailRow labelTop={RESX.Company.resxCompany}>
          <CompanySmallDetails
            company={bookkeeping.company}
            layout="multiLine"
          />
        </PreviewPanelDetailRow>

        {eInvoiceCompliance.displayFeature && <PreviewPanelDetailRow labelTop={"Peppol"}>
          <EInvoiceSenderComplianceMessage
            compliance={eInvoiceCompliance}
          />
        </PreviewPanelDetailRow>}
      </div>

      <BankAccountsSection bankAccounts={bankAccounts} />
    </PreviewPanelContent>
    <PreviewPanelFooter>
      {site.permissions.canConfigureSystemSettings && <ButtonPrimary href={routes.bookkeeping_Detail(bookkeepingId).absolute} label={RESX.Buttons.DetailView} />}
    </PreviewPanelFooter>
  </>;
}

interface BookkeepingPreviewProps {
  bookkeepingId: number
  trigger: JSX.Element
  fallbackIfNoPermission?: JSX.Element
}

export const BookkeepingPreview = (props: BookkeepingPreviewProps) => {
  if (!site.permissions.canConfigureSystemSettings) {
    return props.fallbackIfNoPermission || props.trigger;
  }

  return <PreviewPanel
    trigger={props.trigger}
    size="medium"
    id={`bookkeeping-preview-${props.bookkeepingId}`}>
    <BookkeepingPreviewPanel
      bookkeepingId={props.bookkeepingId}
    />
  </PreviewPanel>;
}